<template>
  <generic-content
      :isLinkable="false"
      :isEditable="true"
      :isDownloadable="payment.bankStatement!=null?true:false"
      :isDeletable="true"
      @click="$emit('click')"
      @edit="$emit('edit')"
      @download="$emit('download')"
      @delete="$emit('delete')"
  >
    <template #iconContent>
      <b-avatar
          size="32"
          variant="light-primary"
          class="my-auto"
      >
        <icon
            :icon="iconPaymentType"
        />
      </b-avatar>
    </template>

    <template #bodyContent>
      <h6 class="transaction-title text-truncate">
        {{ payment.wording }}
      </h6>
      <div class="d-flex justify-content-between text-truncate">
        <small>
          <i>{{ payment.operationDate | moment('L') }}</i>
        </small>
        <small
            :class="payment._balance >= 0?'text-success':'text-danger'"
        >{{ currency(payment._balance) }}
        </small>
      </div>
    </template>

  </generic-content>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { currency } from '../../../utils/filter'

import GenericContent from './Content'
import i18n from '@/libs/i18n'

export default {
  components: {
    GenericContent
  },
  props: {
    payment: {
      type: Object,
      default: () => {}
    }
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const iconPaymentType = computed(() => {
      if (
          props.payment.paymentMethod.name == 'Bank transfert' ||
          props.payment.paymentMethod.name == i18n.t('Bank transfert')
      ) {
        return 'exchange-alt'
      } else if (props.payment.paymentMethod.name == 'Direct debit' ||
          props.payment.paymentMethod.name == i18n.t('Direct debit')) {
        return 'sign-out-alt'
      } else if (props.payment.paymentMethod.name == 'Debit card' ||
          props.payment.paymentMethod.name == i18n.t('Debit card')) {
        return 'credit-card'
      } else if (props.payment.paymentMethod.name == 'Check' ||
          props.payment.paymentMethod.name == i18n.t('Check')) {
        return 'money-check'
      } else if (props.payment.paymentMethod.name == 'Cash' ||
          props.payment.paymentMethod.name == i18n.t('Cash')) {
        return 'money-bill-wave'
      }
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      currency,

      // Data

      // Computed
      iconPaymentType,

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {

  },
  created () {
  }
}
</script>

<style lang="scss">

</style>